// This file contains the types and enums used in the Pet License Report page.
export enum PetType {
    DOG = 'Dog',
    CAT = 'Cat',
    ALL = 'All',
}

// This enum represents the different statuses a pet license can have.
export enum LicenseStatus {
    ALL = 'All',
    EXPIRED = 'Expired',
    EXPIRING_SOON = 'Expiring Soon',
    ACTIVE = 'Active',
}

// This enum represents the different statuses a pet can have.
export enum PetStatus {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
}